export default __webpack_public_path__ + "static/media/walkN.7fd0c611.mp4";